// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueLazyload from 'vue-lazyload'
import VueLocalStorage from 'vue-ls'

var options = {
  namespace: 'vuejs__'
}

Vue.use(VueLocalStorage, options)

Vue.config.productionTip = false

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/static/images/loading-wheel.svg',
  loading: '/static/images/loading-wheel.svg',
  attempt: 1
})

Vue.component('edit-link', {
  props: {
    id: 0
  },
  computed: {
    link: function () {
      return process.env.BACKEND + '/node/' + this.id + '/edit'
    }
  },
  template: '<a class="edit-link" :href="link" target="_blank">Edit</a>'
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
  appClass: 'static',
  data: {
    menuItems: [],
    siteName: 'typeandline'
  }
})



// WEBPACK FOOTER //
// ./src/main.js